
  var _styles = {
  "magicmember-all-btn-container": {
    "display": "flex",
    "alignItems": "center",
    "marginTop": "0.32rem"
  },
  "magicmember-all-btn": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "4.26667rem",
    "height": "1.17333rem",
    "borderRadius": "0.58667rem"
  },
  "magicmember-all-btn-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFangSC-Regular",
    "fontWeight": "600",
    "fontSize": "0.42667rem"
  }
};



  module.exports = _styles;
  